import { render } from "./solofaltan.vue?vue&type=template&id=5f06157e&scoped=true"
import script from "./solofaltan.vue?vue&type=script&lang=js"
export * from "./solofaltan.vue?vue&type=script&lang=js"

import "./solofaltan.vue?vue&type=style&index=0&id=5f06157e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f06157e"]])

export default __exports__